var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcEvseDepot = function SvgIcEvseDepot(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16.691,
    viewBox: "0 0 19 16.691",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #25556e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(-13 -8.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_ev_station_24px",
    className: "cls-1",
    d: "M21.2,7.615l.011-.011L17.156,3.545,16,4.7,18.3,7a2.723,2.723,0,0,0,.971,5.269,2.789,2.789,0,0,0,1.091-.229v5.269a1.091,1.091,0,0,1-2.182,0V15A2.188,2.188,0,0,0,16,12.818H14.909v1.636h1.636v2.858a2.727,2.727,0,0,0,5.455,0V9.545A2.729,2.729,0,0,0,21.2,7.615Zm-1.931,3.022a1.091,1.091,0,1,1,1.091-1.091A1.094,1.094,0,0,1,19.273,10.636Z",
    transform: "translate(10 5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_8",
    "data-name": "Exclusion 8",
    className: "cls-1",
    d: "M1827.091-200.309h-4v-1.922h-2a2,2,0,0,1-2-2V-215a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v10.769a2,2,0,0,1-2,2h-2v1.921Zm-1.344-13.891-3.055,5.729h1.528v3.437l3.055-5.347h-1.528v-3.82Z",
    transform: "translate(-1806.091 225.545)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcEvseDepot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_evse_depot.4c05e5fed7b2a4482fd00810d4675d23.svg";